import React from 'react';
import { useState } from 'react';
import Div from '../Div';
const accordionData = [
  {
    question: 'What services does Vox Motion offer?',
    answer:
      'We specialize in high-impact Video Editing, Motion Graphics, Content Strategy, and Brand Design. Whether you are building a brand from scratch or scaling your content, we craft solutions that are strategic, creative, and visually premium.',
  },
  {
    question: ' How do you handle new projects and collaborations?',
    answer:
      'Every project begins with a discovery call or brief, where we understand your goals, audience, and style. From there, we build a custom roadmap from concept to delivery, with mutual collaboration throughout.',
  },
  {
    question: 'Can I work with you on a monthly or retainer basis?',
    answer:
      'Yes! We offer custom retainers for brands and creators who need consistent content and design support. This ensures priority delivery, strategic alignment, and creative consistency across all your platforms.',
  },
  {
    question: ' What makes Vox Motion different from other studios?',
    answer:
      'Vox Motion is not just a service — it’s a creative partner. We blend aesthetics with strategy to create content that performs. From storytelling to execution, we focus on clarity, retention, and emotional impact - tailored to your brand’s voice.',
  },
  {
    question: 'How do you ensure the content truly reflects our brand and audience?',
    answer:
      'We dive deep into your brand voice, values, and goals before creating anything. Whether it’s video, design, or strategy, our process includes research, moodboarding, and ongoing feedback loops to make sure every piece of content aligns with your vision and speaks to your target audience authentically.',
  },
];

export default function Accordion() {
  const [selected, setSelected] = useState(0);
  const handelToggle = index => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  return (
    <Div className="cs-accordians cs-style1">
      {accordionData.map((item, index) => (
        <Div
          className={`cs-accordian ${selected === index ? 'active' : ''}`}
          key={index}
        >
          <Div
            className="cs-accordian_head"
            onClick={() => handelToggle(index)}
          >
            <h2 className="cs-accordian_title">{item.question}</h2>
            <span className="cs-accordian_toggle cs-accent_color">
              <svg
                width={15}
                height={8}
                viewBox="0 0 15 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0L7.5 7.5L15 0H0Z" fill="currentColor" />
              </svg>
            </span>
          </Div>
          <Div className="cs-accordian_body">
            <Div className="cs-accordian_body_in">{item.answer}</Div>
          </Div>
        </Div>
      ))}
    </Div>
  );
}
